import {useContext} from "react";
import {AuthContext} from "../context/AuthContextObject.ts";


export const useAuth = () => {
    const context = useContext(AuthContext);
    return context;
};
